<div class="media-rotator">
  <img class="full-screen" id="imageViewer" width="100" height="100" [ngSrc]="media?.source" [hidden]="media?.type !== 'image'" />
  <video #videoPlayer
    [hidden]="media?.type !== 'video'"
    class="full-screen" id="videoPlayer" autoplay="autoplay" [muted]="true">
  </video>
</div>
